import { showFlyout } from '../../../Dashboard/actions';
import { useAction } from '../../../Common/hooks';
import { agenciesCreationFlyout } from '../../constants';

const useAgenciesHeader = () => {
  const dispatchShowFlyout = useAction(showFlyout);

  const handleCreateClick = () => {
    dispatchShowFlyout(agenciesCreationFlyout);
  };

  return {
    handleCreateClick,
  };
};

export default useAgenciesHeader;
